import React from 'react';
import {
  IconAISiteBuilder,
  IconAIWordPress, Link,
} from 'gatorcomponents';
import { OTHER_TOOLS_OPTION_IDS } from '@/components/OnboardingHandlerComponents/OtherToolsSuccess/OtherToolsSuccess.enum';
import { CREATE_SITE_TABS } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSite/AiBuilderCreateSite.enum';
import { TEMPLATE_CATEGORIES } from '@/components/OnboardingHandlerComponents/AiBuilderWithTemplate/AiBulderWithTemplate.enum';
import { STEPS } from '@/pages/sites/SitesWizardHandler/SitesWizardHandler.enum';
import sitebuilderImage from '@/media/onboarding/aiBuilder/sitebuilder-ai.png';
import wordpressImage from '@/media/onboarding/aiWordpress/wordpress-ai.png';
import { SEGMENTS_OPTIONS_LIST_BR } from './segments.br';

export default {
  title: 'Onboarding title',
  goBackButtonLabel: 'Voltar',
  continueButtonLabel: 'Continuar',
  sendFileButtonLabel: 'Enviar arquivo',
  chooseSiteOption: {
    title: 'Mostre sua empresa para o mundo, escolha como <strong>criar seu site:</strong>',
    options: [
      {
        id: 0,
        iconTitle: <IconAISiteBuilder color="lowDark" size="md" />,
        title: 'Criador de Sites com IA',
        description: 'Deixe a IA criar seu site com os dados da sua página do Google, ou diga pra ela como quer seu site. Se quiser, escolha um modelo de site pronto.',
        cta: { label: 'Usar Criador de Sites com IA', action: () => { } },
        recommended: 'Recomendado',
        subtitle: 'Para quem é iniciante',
        footerLabel: 'Rápido, fácil e sem precisar de conhecimento técnico.',
        image: {
          src: sitebuilderImage,
          alt: 'Criador de Sites com IA',
        },
      },
      {
        id: 1,
        iconTitle: <IconAIWordPress color="lowDark" size="md" />,
        title: 'Criar site com WordPress',
        description: 'Você escolhe: deixar a IA fazer tudo e alterar depois se quiser ou criar você mesmo com plugins como Elementor e Beaver. Você no controle total.',
        cta: { label: 'Usar WordPress com IA', action: () => { } },
        subtitle: 'Para quem já conhece o WordPress',
        footerLabel: 'Prefere sem IA?',
        ctaFooter: { label: 'Criar manualmente no WordPress', action: () => { } },
        image: {
          src: wordpressImage,
          alt: 'Criar site com WordPress',
        },
      },
    ],
    advancedModeModal: {
      title: 'Quer prosseguir no Modo Avançado?',
      description: 'Esta opção é indicada para quem tem conhecimento técnico. <br/><br/> Você será responsável por toda a implementação (HTML/CSS/JS, frameworks e integrações), build e ajustes finos sem ajuda da IA.',
      exitButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Sim, criar no Modo Avançado',
    },
    normalModeModal: {
      title: 'Tem certeza que quer criar manualmente no WordPress?',
      description: 'Essa opção é recomendada para quem já tem experiência ou conhecimento técnico em WordPress. <br/><br/> Você fará todas as configurações e personalizações por conta própria, sem auxílio da IA.',
      exitButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Sim, criar manualmente',
    },
    haveExperienceLabel: 'Já tem experiência técnica e prefere usar cPanel, FTP ou outras plataformas?',
    ctaAdvancedMode: { label: 'Criar no modo avançado', action: () => { } },
  },
  siteAlreadyExists: {
    title: 'Percebemos que você já tem um site criado',
    description: () => (
      <p>
        Se continuar, seu
        {' '}
        <b>site atual será excluído</b>
        {' '}
        para dar lugar ao novo.
      </p>
    ),
    bulletPoints: {
      title: 'O que fazer?',
      list: [
        'Se quiser seguir com a mudança, basta continuar',
        'Se quiser manter seu site atual, volte e escolha outra opção',
      ],
    },
    checkboxLabel: 'Estou ciente da exclusão do conteúdo e desejo continuar mesmo assim',
    continueButtonLabel: 'Continuar',
    goBackButtonLabel: 'Voltar',
  },
  wordPress: {
    title: 'Site WordPress',
    subtitle: 'com Inteligência Artificial',
    description: 'Crie um nome de usuário e uma senha para sua conta WordPress',
    userLabel: 'Usuário',
    passwordLabel: 'Senha',
    userNameError: 'Use no minímo 6 caracteres sem caracteres especiais',
    passwordError: 'Use no mínimo 8 caracteres, com letras maiúsculas, minúsculas, números e caractere especial',
    wpIaSuccess: isUsingTempDomain => ({
      title: 'Tudo pronto!',
      subtitle: isUsingTempDomain
        ? 'Seu domínio temporário e conta WordPress foram criados com sucesso'
        : 'Agora você pode começar a criar e personalizar seu site do seu jeito, sem precisar de códigos.',
      description: 'Crie um site em minutos com o apoio da Inteligência Artificial',
      infoList: [
        'Personalize facilmente o design e o conteúdo',
        'Edite e publique sem complicações',
      ],
    }),
    wpNormalSuccess: isUsingTempDomain => ({
      title: 'Tudo pronto!',
      subtitle: isUsingTempDomain
        ? 'Seu domínio temporário e conta WordPress foram criados com sucesso'
        : 'Agora você pode começar a criar e personalizar seu site do seu jeito, sem precisar de códigos.',
      description: 'Crie um site com WordPress',
      infoList: [
        'Criação intuitiva sem programação, com temas e plugins personalizáveis',
        'Recursos otimizados para melhor ranqueamento e velocidade do site',
      ],
    }),
    leftButtonLabel: 'Portal do Cliente',
    rightButtonLabel: 'Começar agora',
  },
  domainRegistered: {
    title: 'Escolha um domínio para o seu site',
    description: 'O domínio é o endereço do seu site na internet (como meusite.com)',
    placeholder: 'Nome do domínio',
    alertTitle: 'Tudo certo!',
    alertDescription: 'Seu site será configurado com este domínio. Você poderá ajustá-lo depois, se precisar.',
    success: {
      title: 'Tudo pronto!',
      description: 'Agora você pode começar a criar e personalizar seu site do seu jeito, sem precisar de códigos.',
      infoList: [
        'Personalize seu site com layouts prontos e edite com apenas alguns cliques.',
        'Adicione seu conteúdo e veja seu site tomando forma em tempo real.',
        'Publique quando estiver pronto e compartilhe seu site com o mundo!',
      ],
      leftButtonLabel: 'Portal do Cliente',
      rightButtonLabel: 'Começar agora',
    },
    selectDomainLabel: 'Selecionar domínio ou subdomínio',
    wantToUseAnotherDomain: 'Quero usar outro domínio ou subdomínio',
    usingTempDomain: {
      title: 'Domínio Temporário',
      description: 'Você terá um endereço temporário para acessar e editar seu site agora',
      tempDomainInfo: [
        'O domínio temporário será gerado e exibido na etapa final.',
        'Um domínio próprio demora mais tempo, e pode ser definido quando o site estiver pronto',
      ],
      understandTheDifference: (
        <Link
          target="_blank"
          href="https://suporte.hostgator.com.br/hc/pt-br/articles/38717544355603-O-que-%C3%A9-e-como-funciona-o-dom%C3%ADnio-tempor%C3%A1rio#diferencas"
          text="Entenda a diferença entre o domínio temporário e próprio"
        />
      ),
    },
    inputErrors: {
      startOrEndWithHyphen: 'O domínio não pode começar ou terminar com hífen',
      twoHyphensInARow: 'O domínio não pode ter dois hífens seguidos',
      lessThanThreeCharacters: 'Use 3 caracteres ou mais para seu domínio',
      hasSpecialChars: 'O domínio não pode ter caracteres especiais, com exceção do hífen',
    },
  },
  otherTools: {
    title: 'Tudo pronto!',
    description: 'Escolha o caminho que faz mais sentido para você e comece a construir seu site!',
    options: [
      { title: 'Acessar o cPanel', description: 'Gerencie sua hospedagem, configure banco de dados e e-mails e acesse o FTP para enviar arquivos ao servidor.', id: OTHER_TOOLS_OPTION_IDS.CPANEL },
      { title: 'Explorar o Softaculous', description: 'Instale ferramentas para o seu site com poucos cliques, sem configurações manuais.', id: OTHER_TOOLS_OPTION_IDS.SOFTACULOUS },
      { title: 'Dados de acesso ao FTP', description: 'Envie arquivos direto para o servidor. Você também encontra esses dados no cPanel e no Portal HostGator.', id: OTHER_TOOLS_OPTION_IDS.FTP },
    ],
    leftButtonLabel: 'Voltar',
    rightButtonLabel: 'Continuar',
  },
  buyPlan: {
    title: 'Você precisa de um plano maior para seguir',
    subtitle: 'Parece que seu plano atual não permite adicionar novos sites. Mas não se preocupe, é fácil resolver!',
    description: 'Como continuar?',
    list: [
      'Faça um upgrade no seu plano para liberar a criação de novos sites',
      'Depois, reinicie o fluxo para configurar seu site',
    ],
  },
  selectPlanList: {
    title: 'Escolha um dos planos ativos abaixo',
    domainText: 'Domínio Principal:',
  },
  externalDomain: {
    title: domain => `O domínio “${domain}” foi registrado em outra empresa`,
    subtitle: 'Precisa de ajuda para conectar seu site?',
    info: (
      <>
        Para vinculá-lo corretamente, aponte o DNS para nossa hospedagem.
        <a
          target="_blank"
          rel="noreferrer"
          href="https://suporte.hostgator.com.br/hc/pt-br/articles/6597512530331-Como-configurar-o-dom%C3%ADnio-alterar-DNS-em-outro-provedor-Registro-br-UOL-Host-GoDaddy-Locaweb-KingHost"
        >
          Saiba como na Central de Ajuda.
        </a>
      </>
    ),
    continueButtonLabel: 'Portal do Cliente',
    startNow: 'Começar agora',
  },
  configuredDnsSuccess: {
    title: 'Pronto! Seu domínio está sendo configurado com sucesso',
    description: 'Aguarde até 2 horas para o site entrar no ar com o novo domínio',
    infoList: [
      'Após a publicação, aguarde a propagação do site antes de avançar com a ferramenta de criação selecionada.',
    ],
    continueButtonLabel: 'Portal do Cliente',
  },
  domainNotRegistered: {
    title: domain => `O domínio “${domain}” está disponível para compra`,
    subtitle: 'Caso prefira, pode continuar a configuração agora com um domínio temporário.',
    list: [
      'O domínio temporário permite você construir seu site sem precisar configurar um domínio próprio',
      'Quando seu site estiver completo você poderá alterar para um domínio próprio no Portal do Cliente',
    ],
  },
  chooseWpMigrationStep: {
    title: 'Defina como você deseja prosseguir',
    options: [
      {
        id: 0, title: 'Criar Site', description: 'Escolha a ferramenta de criação de sites mais adequada para o seu aprojeto e comece a criar agora mesmo.', cta: { label: 'Criar Site', action: () => { } },
      },
      {
        id: 1, title: 'Migrar Site WordPress', description: 'Migre seu site WordPress para nossos servidores enviando os arquivos de backup ou fornecendo os dados de acesso via FTP.', cta: { label: 'Migrar Site WordPress', action: () => { } },
      },
    ],
    continueLater: 'Criar ou migrar site depois',
  },
  chooseMigrationOption: {
    title: 'Migrar site WordPress',
    description: 'Escolha a melhor forma para trazer seu site para cá:',
    filesMigration: {
      id: 'files',
      title: 'Migrar com arquivos',
      description: 'Tem um backup do seu site? Basta fazer o upload do arquivo para começarmos a migração.',
      tag: 'Recomendado',
    },
    ftpMigration: {
      id: 'ftp',
      title: 'Migrar com dados FTP',
      description: 'Prefere migrar direto do servidor? Informe os dados de FTP que cuidamos do resto.',
    },
  },
  ftpMigrationForm: {
    title: 'Migra site WordPress com dados FTP',
    description: 'Envie as informações FTP para migrar um site WordPress',
    form: {
      userName: 'Usuário FTP',
      password: 'Senha FTP',
      databaseName: 'Nome do banco de dados de destino',
      sourcePath: 'Diretório do site de origem',
      sourceIp: 'IP ou nome do servidor de origem',
      sourceDomain: 'Domínio de origem',
      destinationPath: 'Diretório de destino',
      sourcePort: 'Porta do servidor de origem',
    },
    questions: (
      <p>
        <span>Dúvidas?</span>
        {' '}
        <a href="https://suporte.hostgator.com.br/hc/pt-br/articles/30814715933587" target="_blank" rel="noreferrer">
          Acesse um material sobre como migrar site com dados FTP.
        </a>
      </p>
    ),
    toast: {
      title: 'Erro no Envio dos Dados FTP',
      info: 'Houve um problema ao enviar as informações de FTP. Por favor, revise os dados inseridos e tente novamente.',
    },
    required: 'Obrigatório',
    optional: 'Opcional',
  },
  filesMigration: {
    title: 'Migrar com arquivos',
    description: (
      <>
        <span>
          {'Envie um arquivo '}
          <strong>.zip</strong>
          {' contendo todos os arquivos do seu site WordPress.'}
        </span>
        <span>
          {'Envie também o arquivo '}
          <strong>.sql</strong>
          {' do banco de dados correspondente.'}
        </span>
      </>
    ),
    doubt: (
      <>
        {'Dúvidas? '}
        <Link
          text="Acesse um material sobre como migrar com um arquivo."
          href="https://suporte.hostgator.com.br/hc/pt-br/articles/35196944159507"
          target="_blank"
        />
      </>
    ),
    processLabel: 'Processando',
    storeSpace: 'Armazenamento',
    dragText: 'Clique para selecionar os arquivos ou arraste e solte-os aqui',
    migrationError: {
      title: type => `Erro no envio arquivo .${type}`,
      description: 'Verifique se os dados inseridos estão corretos e tente novamente. Caso precise substituir o arquivo, remova o anterior clicando no "X".',
    },
    fileSizeError: {
      title: 'Erro no envio do arquivo',
      description: size => `Os arquivos excedem o limite de ${size}GB permitido. Por favor, envie arquivos menores. Caso precise substituir o arquivo, remova o anterior clicando no "X".`,
    },
  },
  migrationSuccess: {
    title: 'Migração em Andamento!',
    description: 'Estamos processando a migração do seu site',
    infoList: [
      <>
        Assim que a migração for concluída,
        {' '}
        <b>você receberá uma notificação em &quot;Meus Avisos&quot;.</b>
        {' '}
        Enquanto isso, você pode retornar ao Painel do Cliente.
      </>,
    ],
    continueButtonLabel: 'Portal do Cliente',
  },
  aiBuilderCreateSite: {
    loadingTitles: [
      'Estou criando seu site',
      'Procurando o melhor estilo',
      'Agora escolhendo imagens e textos',
      'Só um segundo, está incrível!',
    ],
    steps: {
      [CREATE_SITE_TABS.NAME]: {
        promoBannerTitle: (
          <>
            {'Crie '}
            <strong>sites incríveis</strong>
            {' com IA'}
          </>
        ),
        label: 'Nome do site',
        title: 'Olá, vou te ajudar a criar seu site!',
        inputHeadText: 'Qual o nome do site? Pode ser da sua empresa ou marca.',
        inputPlaceholder: 'Digite o nome',
        buttonLabel: 'Próximo passo',
      },
      [CREATE_SITE_TABS.SEGMENT]: {
        promoBannerTitle: (
          <>
            {'Seu '}
            <strong>negócio online</strong>
            {' com IA'}
          </>
        ),
        label: 'Segmento',
        title: 'Agora me conta. Qual o tipo de negócio?',
        inputHeadText: 'Escolha um segmento para o seu site.',
        inputPlaceholder: 'Digite ou escolha um segmento',
        buttonLabel: 'Próximo passo',
        optionsList: SEGMENTS_OPTIONS_LIST_BR,
      },
      [CREATE_SITE_TABS.INFOS]: {
        promoBannerTitle: (
          <>
            {'Mostre para o '}
            <strong>mundo</strong>
            {' seu site'}
          </>
        ),
        label: 'Informações',
        title: 'E pra fechar, me fala da sua empresa',
        subtitle: 'Fale sobre o seu negócio, sua marca ou serviço',
        subtitleTooltip: 'Exemplo: “Tenho um restaurante de comida saudável, especializado em saladas, para pessoas que buscam uma alimentação leve. Quero um site no estilo moderno e colorido, mostrando o cardápio e com opção para fazer pedidos online.”',
        textAreaLabel: 'Descreva o que você faz, para quem é seu site...',
        contactInfos: 'Informações de contato',
        contactInfosDescription: 'Elas irão aparecer no seu site para que as pessoas possam entrar em contato com você.',
        optional: '(opcional)',
        telephonePlaceholder: 'Digite seu telefone',
        emailPlaceholder: 'Digite seu e-mail',
        buttonLabel: 'Crie meu site agora',
        emailTooltip: 'Insira um e-mail válido para continuar',
        errors: {
          genericError: 'Preencha corretamente todos os campos',
          emailError: 'Insira um e-mail válido',
          telephoneError: 'Insira um número de telefone válido',
        },
      },
    },
  },
  aiBuilderMyBusiness: {
    loadingTitles: [
      'Estou criando seu site',
      'Procurando o melhor estilo',
      'Agora escolhendo imagens e textos',
      'Só um segundo, está incrível!',
    ],
    promoBannerTitle: (
      <>
        {'Crie sites incríveis '}
        <strong>{'com IA '}</strong>
      </>
    ),
    content: {
      loadingTitles: [
        'Estou criando seu site',
        'Procurando o melhor estilo',
        'Agora escolhendo imagens e textos',
        'Só um segundo, está incrível!',
      ],
      label: 'Nome do site',
      title: 'Oi, sou o Gator, a inteligência artificial que vai criar seu site!',
      inputLabel: 'Preciso localizar os dados da sua empresa',
      inputPlaceholder: 'Nome da empresa',
      buttonLabel: 'Crie meu site',
      notFoundCompany: {
        text: 'Não encontrou sua empresa? ',
        linkText: 'Volte e escolha outra opção',
      },
    },
  },
  aiBuilderWithTemplate: {
    title: (
      <>
        Escolha um
        <strong>{' modelo '}</strong>
        de site pronto
      </>
    ),
    categoriesList: [
      { value: TEMPLATE_CATEGORIES.ALL, label: 'Todos' },
      { value: TEMPLATE_CATEGORIES.LAYOUTS, label: 'Modelos' },
      { value: TEMPLATE_CATEGORIES.FREE, label: 'Página de vendas' },
      { value: TEMPLATE_CATEGORIES.BUSINESS, label: 'Negócios' },
      { value: TEMPLATE_CATEGORIES.EDUCATION, label: 'Cursos' },
      { value: TEMPLATE_CATEGORIES.FOOD, label: 'Comidas' },
      { value: TEMPLATE_CATEGORIES.ART_MUSIC, label: 'Artes e Músicas' },
      { value: TEMPLATE_CATEGORIES.PORTFOLIO, label: 'Portfólios' },
      { value: TEMPLATE_CATEGORIES.SPORT, label: 'Esporte e saúde' },
      { value: TEMPLATE_CATEGORIES.TRAVEL, label: 'Viagens' },
      { value: TEMPLATE_CATEGORIES.SHOP, label: 'Loja' },
    ],
    openTemplateButtonLabel: 'Criar com esse modelo',
    openPreviewButtonLabel: 'Mostrar prévia',
    loadingTitles: [
      'Estou criando seu site',
      'Procurando o melhor estilo',
      'Agora escolhendo imagens e textos',
      'Só um segundo, está incrível!',
    ],
    continueWithTemplateModal: {
      title: 'Você quer continuar com este modelo ou prefere escollher outro?',
      description: ' Se decidir mudar depois, será preciso excluir o modelo escolhido e todo o conteúdo criado será apagado. Após selecionar um modelo de site, ele será salvo automaticamente em sua hospedagem.',
      changeTemplateButtonLabel: 'Procurar por outro',
      continueButtonLabel: 'Quero este modelo',
    },
    genericError: {
      title: (
        <>
          Ocorreu um erro ao carregar os modelos de site.
          {' '}
          <br />
          Caso persista, tente novamente mais tarde.
        </>
      ),
      buttonLabel: 'Tentar novamente',
    },
    searchTemplateLabel: 'Buscar modelo',
    emptyTemplateText: 'Não encontramos modelos para esse termo Explore outras opções',
    emptyTemplateCta: 'Ver todos os modelos',
  },

  genericErrorTitle: 'Algo deu errado',
  genericErrorInfo: 'Por favor tente novamente mais tarde',
  useTempDomain: 'Usar um domínio temporário',
  useOwnedDomain: 'Usar domínio próprio',
  siteBuilderV2: {
    topBannerTitle: (
      <>
        Ter um site é
        {' '}
        <strong>mais simples</strong>
        {' '}
        do que você imagina
      </>
    ),
    title: 'Como você quer criar seu site? Escolha uma opção',
    subtitle: 'Tudo bem mudar de ideia! Se quiser, é só voltar depois e escolher outra opção.',
    ctaContinue: 'Continuar',
    cardsList: {
      [STEPS.IA_BUILDER_MY_BUSINESS]: {
        title: 'Com IA e os dados da minha empresa',
        desc: 'Use a página da sua empresa no Google. A nossa IA pega essas informações para criar seu site em minutos.',
      },
      [STEPS.IA_BUILDER_CREATE_SITE]: {
        title: 'Com a IA criando tudo',
        desc: 'Conte tudo para IA: quem é seu público, o que você faz ou vende. Ela cria seu site e você ainda pode alterar o que quiser.',
      },
      [STEPS.IA_BUILDER_WITH_TEMPLATE]: {
        title: 'Com um modelo de site pronto',
        desc: 'São mais de 200 modelos de sites prontos para usar. Um mais bonito que o outro. Encontre seu site, personalize e altere o que precisar.',
      },
    },
    exitConfirmModal: {
      title: 'Tem certeza que deseja sair do Criador de sites com IA?',
      description: 'Se sair agora, todas as alterações feitas serão perdidas e você terá de começar do zero.',
      exitButtonLabel: 'Quero sair',
      cancelButtonLabel: 'Cancelar',
    },
    factoryAgent: {
      siteCreated: {
        title: 'Missão cumprida: Seu site já está pronto',
        description: 'Confira como ficou seu site. Altere o que quiser: conteúdo, cores, textos e muito mais em editar site. Depois comece a atrair clientes e gerar resultados.',
        button: 'Editar site',
      },
      agentBlock: {
        title: 'Você acaba de ganhar um agente de atendimento para seu site! 🎉',
        subtitle: 'Crie seu agente para atender seus clientes rápido e fácil.',
        benefits: {
          customize: 'Personalize e humanize seu assistente',
          integrateBussiness: 'Integre as informações do seu negócio',
          integrateSite: 'Integre o assistente em seu site',
          easyCreate: 'Fácil criação em poucos cliques sem código',
        },
        button: 'Quero meu agente',
      },
    },
  },
  sitebuilderPreview: {
    tooltips: {
      computer: 'Computador',
      tablet: 'Tablet',
      mobile: 'Celular',
    },
    ctaButtons: {
      generateNewSite: 'Gerar novo site',
      useThisSite: 'Usar este site',
    },
    loadingTitles: [
      'Estou criando seu site',
      'Procurando o melhor estilo',
      'Escolhendo as cores e textos',
      'Só um segundo, está incrível!',
    ],
    loadingTitlesPublish: [
      'Iniciando a publicação do seu site...',
      'Garantindo a melhor velocidade para seus clientes.',
      'Conectando sua empresa ao mundo digital.',
      'Tudo pronto! Seu site já está no ar.',
    ],
  },
};
